import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer>
      <p>
        For educational purposes only, not financial advice. Terms &amp; conditions apply.
      </p>
      <nav aria-label="Legal">
        <Link to="/privacy-policy" data-testid="privacy-link">Privacy</Link>
        <Link to="/terms-of-service" data-testid="terms-link">Terms</Link>
      </nav>
    </footer>
  );
}
